import { useEffect, useRef } from 'react';

/**
 * Returns a ref whose `.current` value is always kept in sync with the
 * provided value. Useful for reading the latest value inside callbacks
 * without adding the value to the dependency array.
 */
export const useSyncedRef = <T>(value: T) => {
  const valueRef = useRef(value);
  useEffect(() => {
    valueRef.current = value;
  }, [value]);
  return valueRef;
};
